import { throwError } from 'rxjs';
import { ErrorModel, ResponseModel, UserImageResponseModel } from '@core/api';
import { FormGroup } from '@angular/forms';
import { catchError } from 'rxjs/operators';
import { HttpStatusCode } from '@core/enums/http-status-code';
import { FormService } from '@core/services';
import { Form } from '@core/components/interfaces/renter-form/form';

import * as moment from 'moment';
import { Observable } from 'rxjs/index';
import { ValidateError } from '@core/errors/validate.error';
import { of } from 'rxjs/internal/observable/of';


export abstract class BaseService implements Form{

  protected constructor(protected formService: FormService) { }

  abstract buildForm();
  abstract resetForm();
  abstract markFormGroupTouched();

  protected formatDate(date: string | Date) {
    return moment(date).format('YYYY-MM-DD');
  }

  protected catchErrorFactory<T>(form: FormGroup) {
    return catchError<T, T>((err) => {
      this.catchServerError(form, err);

      return throwError(err);
    });
  }

  protected catchServerError(form: FormGroup, error: ErrorModel) {
    this.formService.serverValidateForm(form, error);

    if (error.status === HttpStatusCode.BAD_REQUEST) {
      this.resetForm();
    }
  }

  protected imagesUploadFactory(form: FormGroup, factory: (type) => Observable<ResponseModel<UserImageResponseModel>> ) {
    if (form.invalid) {
      return [throwError(new ValidateError('Error images validation'))];
    }

    const requestImages: Array<Observable<ResponseModel<UserImageResponseModel>>> = [];

    Object.keys(form.value).forEach((type: any) => {
      if(form.value[type] instanceof File) {
        requestImages.push(
          factory(type).pipe(catchError((err) => {
            err.errors[type] = err.errors && err.errors.image;

            this.catchServerError(form, err);

            return throwError(err);
          }))
        );
      } else {
        requestImages.push(of({
          data: form.value[type],
          success: true
        }));
      }
    });

    return requestImages;
  }
}
